export default function ErrorFallback() {
  return (
    <div
      role="alert"
      style={{
        padding: "2rem",
        textAlign: "center",
        maxWidth: "32rem",
        margin: "4rem auto",
      }}
    >
      <h2>Niečo sa pokazilo</h2>
      <p>
        Skús obnoviť stránku. Ak problém pretrváva, kontaktuj nás na{" "}
        <a href="mailto:info@claystudio.sk">info@claystudio.sk</a>.
      </p>
      <button onClick={() => window.location.reload()}>Obnoviť stránku</button>
    </div>
  );
}
